<template>
  <navbar :show-navbar="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-toggle" :class="{ toggled: $sidebar.showSidebar }">
        <navbar-toggle-button
          @click.native="toggleSidebar"
        ></navbar-toggle-button>
      </div>
      <a class="navbar-brand">{{ $route.name }}</a>
    </div>
    <button
      @click="toggleNavbar"
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navigation"
      aria-controls="navigation-index"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>

    <template slot="navbar-menu">
      <ul class="navbar-nav">
        <router-link
          v-if="isSaasBilledTenant && (billingBlocked || subscriptionIsExpired)"
          to="/start?pay=1"
          tag="a"
          class="text-danger pl-3 pr-3 font-weight-bold"
        >
          Add a card to keep using Smartbooks
        </router-link>
        <!-- <router-link
          v-if="$can('create', 'BOOKINGS')"
          to="/bookings/add"
          class="mr-3"
        >
          <n-button type="info" native-type="button">
            <strong> <i class="fa fa-plus-circle pr-2" />Booking</strong>
          </n-button>
        </router-link> -->
        <!-- <router-link
          v-if="$can('create', 'INVOICES')"
          to="/invoices/add"
          class="mr-3"
        >
          <n-button type="info" native-type="button">
            <strong> <i class="fa fa-plus-circle pr-2" />New Invoice </strong>
          </n-button>
        </router-link> -->
        <li class="nav-item">
          <router-link tag="a" class="nav-link" to="/help">
            <i class="now-ui-icons travel_info"></i
          ></router-link>
        </li>
        <drop-down
          tag="li"
          position="right"
          class="nav-item"
          icon="now-ui-icons users_single-02"
          hide-arrow
        >
          <!-- <div class="dropdown-divider"></div> -->
          <router-link tag="a" class="dropdown-item" to="/account">
            {{ $t("message.profile") }}
          </router-link>
          <a class="dropdown-item" v-on:click="$emit('on-logout')">{{
            $t("message.logout")
          }}</a>
        </drop-down>
      </ul>
    </template>
  </navbar>
</template>
<script>
import { RouteBreadCrumb, Navbar, NavbarToggleButton } from "src/components";
import { CollapseTransition } from "vue2-transitions";
import { mapGetters } from "vuex";

export default {
  components: {
    RouteBreadCrumb,
    Navbar,
    NavbarToggleButton,
    CollapseTransition
  },
  computed: {
    ...mapGetters([
      "subscriptionIsTrialPeriod",
      "subscriptionIsBasic",
      "subscriptionIsExpired",
      "billingBlocked",
      "isSaasBilledTenant"
    ]),
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  },
  watch: {
    $route() {
      this.showNavbar = false;
    }
  }
};
</script>
